enum MailingListRoutes {
  List = '/mailing-list',
  Item = '/mailing-list/:id',
}

export default MailingListRoutes
